module.exports = __webpack_public_path__ + "img/e-learning.600fe6ce.svg";